
interface ChipComponentProps {
    text: string;
    variant?: "success" | "warning" | "error" | "info" | "default";
}

const variants = {
   primary: "text-primary border-[var(--custom-button-highlight-border)] border-[0.25px] bg-[var(--custom-button-background-highlight)]",
   default: "text-gray-600 border-gray-300 border-[0.25px] bg-gray-100",
   info: "text-blue-600 border-blue-300 border-[0.25px] bg-blue-100",
   success: "text-green-600 border-green-300 border-[0.25px] bg-green-100",
   warning: "text-yellow-600 border-yellow-300 border-[0.25px] bg-yellow-100",
   error: "text-red-600 border-red-300 border-[0.25px] bg-red-100",
};

const ChipComponent = ({ text, variant }: ChipComponentProps) => {
    const variantClass = variants[variant || 'primary'];

    return (
        <span className={`px-3 py-1 text-xs font-semibold border rounded-lg mb-6 ${variantClass}`}>
            {text.charAt(0).toUpperCase() + text.slice(1)}
        </span>
    );
};

export default ChipComponent;
